export default __webpack_public_path__ + "static/media/Ch1a.37c215de.gif";